export const MuiCardActionArea = {
  styleOverrides: {
    root: {
      fontSize: 'unset',
      padding: 'unset',
      background: 'unset',
      border: 'unset',
      borderRadius: 'unset',
      color: 'unset',
      fontWeight: 'unset',
      lineHeight: 'unset',
      '&:hover $focusHighlight': {
        opacity: 0,
      },
      '&:hover': {
        backgroundColor: 'inherit',
      },
    },
  },
};
